<template>
    <div id="plan">
        <div class="material-icons time-icon">sync_alt</div>
        <div class="content">
            <div class="header" @click="changeVisible">
                <div class="header-titles">
                    <span class="header-title">Planlama Zaman Aralığı</span>
                    <span class="header-sub-title">Randevu alınabilecek zaman aralığını sınırlayın.</span>
                </div>
                <div class="material-icons" v-if="contentVisible">expand_less</div>
                <div class="material-icons" v-else>expand_more</div>
            </div>
            <div v-if="contentVisible">
                <a-radio-group v-model:value="selectedDate" class="radio-btns">
                    <a-radio class="radio-btn" :value="1">Şuan da müsait</a-radio>
                    <a-radio class="radio-btn" :value="2" @click="modalVisible = true"
                        >Başlangıç ve bitiş tarihleri
                    </a-radio>
                </a-radio-group>
                <div class="section">
                    <div class="label">En fazla kaç gün sonrası randevu alınabileceği</div>
                    <div style="margin-top: 5px">
                        <input class="input-checkbox" type="checkbox" v-model="plan.isMaxBookingDay" />
                        <input
                            class="input-number"
                            type="number"
                            v-model="plan.maxBookingDay"
                            :disabled="!plan.isMaxBookingDay"
                            min="1"
                        />
                        <span>gün</span>
                    </div>
                </div>
                <div class="section bottom">
                    <div class="label">Randevunun başlangıcından minimum ne kadar süre önce randevu alınabileceği</div>
                    <div style="margin-top: 5px">
                        <input class="input-checkbox" type="checkbox" v-model="plan.isMinBookingHour" />
                        <input
                            class="input-number"
                            type="number"
                            v-model="plan.minBookingHour"
                            :disabled="!plan.isMinBookingHour"
                            min="1"
                        />
                        <span>saat</span>
                    </div>
                </div>
            </div>
        </div>
        <Modal2 v-if="modalVisible" :show-title="false" @cancel="modalVisible = false" :show-footer="false">
            <div class="d-flex flex-column modal-container">
                <div class="title">Planlama aralığı başlangıç ve bitiş tarihleri</div>
                <div style="margin-left: 50px">
                    <div>Başlangıç Zamanı</div>
                    <a-radio-group v-model:value="selectedStart" class="radio-btns">
                        <a-radio class="radio-btn" :value="1">Şimdi</a-radio>
                        <a-radio class="radio-btn" :value="2"
                            ><input :disabled="selectedStart === 1" type="date" v-model="startDate" class="date"
                        /></a-radio>
                    </a-radio-group>
                </div>
                <div style="margin-left: 50px">
                    <div>Bitiş</div>
                    <a-radio-group v-model:value="selectedEnd" class="radio-btns">
                        <a-radio class="radio-btn" :value="1">Asla</a-radio>
                        <a-radio class="radio-btn" :value="2"
                            ><input :disabled="selectedEnd === 1" type="date" v-model="endDate" class="date"
                        /></a-radio>
                    </a-radio-group>
                </div>
                <div class="footer">
                    <span class="footer-btn" @click="modalVisible = false">İptal</span>
                    <span class="footer-btn" @click="changeValue()">Bitti</span>
                </div>
            </div>
        </Modal2>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../../../utils/log2";
import Modal2 from "../../../../../components/common/Modal2.vue";
import moment from "moment";
import _ from "lodash";

const log = log2("Availability");
export default {
    name: "Availability",
    components: { Modal2 },
    props: {
        value: {
            type: Object,
        },
    },
    data() {
        return {
            plan: _.cloneDeep(this.value),
            contentVisible: false,
            modalVisible: false,
            selectedDate: 1,
            selectedStart: 1,
            selectedEnd: 1,
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment().add(1, "month").format("YYYY-MM-DD"),
            countChange: 1,
        };
    },
    computed: {
        ...mapState({}),
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({}),
        ...mapMutations({}),
        changeVisible() {
            this.contentVisible = !this.contentVisible;
        },
        changeValue() {
            this.plan.customProgramDates.startDate = this.startDate;
            if (this.selectedEnd === 1) this.plan.customProgramDates.endDate = null;
            else this.plan.customProgramDates.endDate = this.endDate;
            this.modalVisible = false;
        },
    },
    async mounted() {
        this.selectedDate = this.plan.isAvailableNow ? 1 : 2;
        this.startDate = moment(this.plan.customProgramDates.startDate).format("YYYY-MM-DD");
        this.endDate = moment(this.plan.customProgramDates.endDate).format("YYYY-MM-DD");
        this.selectedEnd = !this.$route.params.id || this.plan.customProgramDates.endDate === null ? 1 : 2;
        this.selectedStart = !!this.$route.params.id ? 2 : 1;
    },
    beforeDestroy() {},
    watch: {
        plan: {
            handler(val) {
                this.$emit("input", val);
            },
            deep: true,
        },
        selectedDate(val) {
            if (this.countChange > 1) this.modalVisible = val.toString() === "2";
            this.countChange += 1;
            this.plan.isAvailableNow = val.toString() === "1";
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-container {
    background-color: white;
    margin: -20px;
    width: auto;
    padding: 20px;

    .title {
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 10px;
        text-align: center;
    }

    .radio-btns {
        margin: 3px 0;
        display: flex;
        flex-direction: column;

        .radio-btn {
            margin-top: 5px;
            display: flex;
            align-items: center;
        }
    }

    .date {
        border: none;
        background-color: #e2e2e2;
        padding: 5px;
        border-radius: 10px;
    }

    .footer {
        display: flex;
        justify-content: end;

        .footer-btn {
            background-color: #4776b3;
            color: white;
            padding: 1px 10px;
            border-radius: 10px;
            margin-right: 20px;
            font-size: 13px;
            font-weight: 500;
            cursor: pointer;
        }
    }
}

#plan {
    display: flex;
    flex-direction: row;
    margin-top: 20px;

    .time-icon {
        margin-top: 7px;
        margin-right: 20px;
        font-size: 20px;
    }

    .content {
        display: flex;
        flex-direction: column;
        width: 100%;

        .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
            cursor: pointer;
            border-radius: 5px;
            padding: 5px;

            &:hover {
                background-color: #e3e3e3;
            }

            .header-titles {
                display: flex;
                flex-direction: column;

                .header-title {
                    color: black;
                    font-weight: 500;
                    font-size: 16px;
                }

                .header-sub-title {
                    font-size: 12px;
                }
            }
        }

        .radio-btns {
            margin: 10px 0;
            display: flex;
            flex-direction: column;

            .radio-btn {
                margin-top: 5px;
                display: flex;
                align-items: center;
            }
        }

        .section {
            display: flex;
            flex-direction: column;
            margin-top: 10px;

            &.bottom {
                margin-top: 20px;
            }

            .input-checkbox {
                margin-right: 10px;
            }

            .label {
                font-size: 12px;
                font-weight: 700;
            }

            .input-number {
                margin-right: 10px;
                border: none;
                background-color: #e3e3e3;
                border-radius: 5px;
                height: 35px;
                width: 60px;
                padding: 10px;
            }
        }
    }
}
</style>
